import PropTypes from 'prop-types';
import UserDetail from "components/ui/UserDetail/UserDetail";
import Button from "components/ui/Button/Button";
import MessageCreate from "pages/MessageBox/MessageCreate";
import { useDialog } from "context/DialogContext";
import { useAccount } from "context/AccountContext";
import "pages/MessageBox/Message.scss";
import { useEffect } from "react";
import useData from "hooks/useData";
import HTMLContainer from "components/ui/HTML/HTMLContainer";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { ReactComponent as IconAttachment } from "assets/images/icons/attachment.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/trashfull.svg";
import MessageDelete from "pages/MessageBox/MessageDelete";

const Message = ({
                   id,
                   created,
                   profile,
                   message,
                   image,
                   isRead,
                   isExpanded,
                   onSelect,
                   onReplied,
                   onRead,
                   onDeleted
                 }) => {
  const { patchData } = useData();
  const { user } = useAccount();
  const { showDialog } = useDialog();
  const isOwnMessage = user.id === parseInt(profile.uid);

  useEffect(
    () => {
      const setRead = async () => {
        if (!isOwnMessage && isExpanded && !isRead) {
          const result = await patchData(id, 'message', { 'unread': false });
          if (result?.status === 200) {
            onRead(profile.uid);
          }
        }
      }

      setRead();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ id, isExpanded, isOwnMessage, isRead ]);

  return (
    <div className={ `message ${ !isExpanded ? 'message--collapsed' : '' }` } onClick={ () => onSelect(id) }>
      {
        isExpanded
          ?
          <>
            <div className={ 'margin-bottom-small' }>
              <div className={ 'message-controls__date' }>
                { created.long } - { isOwnMessage ? 'U' : profile?.title?.value } schreef:
              </div>
              <HTMLContainer>
                { message.full }
              </HTMLContainer>
              {
                image?.value &&
                <ResponsiveImage value={ image.value }/>
              }
            </div>

            {
              !isOwnMessage &&
              <Button variant={ 'secondary' }
                      className={ 'margin-right-extra-small button--small' }
                      onClick={ () => showDialog(<MessageCreate receiver={ profile }
                                                                replyToMessage={ message.full }
                                                                onCompleted={ onReplied }/>) }>
                Beantwoorden
              </Button>
            }

            <Button variant={ `ghost` }
                    onClick={ () => showDialog(<MessageDelete id={ id }
                                                              onCompleted={ onDeleted }/>) }
                    className={ `button--small` }>
              <IconTrash/>
              Verwijderen
            </Button>
          </>
          :
          <>
            <div className={ 'message__user' }>
              <UserDetail username={ isOwnMessage ? 'U' : profile?.title?.value }
                          image={ profile?.field_profile_photo?.value }
                          subtext={ message.teaser }/>
            </div>
            {
              image?.value &&
              <div className={ `message__attachment` }>
                <IconAttachment/>
              </div>
            }
            {
              !isRead &&
              <div className={ `message__new` }>
                Nieuw
              </div>
            }
            <div className={ 'message__date' }>
              { created.short }
            </div>
          </>
      }
    </div>
  )
}

Message.propTypes = {
  id: PropTypes.number.isRequired,
  created: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  image: PropTypes.object,
  isRead: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onReplied: PropTypes.func.isRequired,
  onRead: PropTypes.func.isRequired,
}

export default Message;
